import React from "react";
import { ControllerRenderProps } from "react-hook-form";
import { CheckboxGroup, InputLayout, RadioGroup, Select, Stars, Text } from ".";
import { Field, Type } from "../../configuration";

export interface InputFactoryProps {
  hookFormField: ControllerRenderProps;
  field: Field;
  error?: string;
}

export function Input({ field, hookFormField }: InputFactoryProps) {
  switch (field.type) {
    case Type.CHECKBOX:
      return (
        <CheckboxGroup options={field.options} {...field} {...hookFormField} />
      );
    case Type.RADIO:
      return (
        <RadioGroup options={field.options} {...field} {...hookFormField} />
      );
    case Type.STARS:
      return <Stars {...hookFormField} />;
    case Type.SELECT:
      return (
        <Select
          placeholder="Please Select Option"
          options={field.options}
          {...field}
          {...hookFormField}
        />
      );
    default:
      return (
        <Text
          type={field.type}
          {...hookFormField}
          className="block pl-7 pr-12 py-4 rounded-full w-full placeholder:text-font-400 text-novartis-font font-semibold outline-none shadow-leap focus:ring-2 focus:ring-survey-brand"
        />
      );
  }
}

export default function InputFactory({
  hookFormField,
  field,
  error,
}: InputFactoryProps) {
  return (
    <InputLayout label={field.label} name={field.name} error={error}>
      <Input field={field} hookFormField={hookFormField} />
    </InputLayout>
  );
}
